module.exports = __webpack_public_path__ + "static/media/Screenshot4.fe1ec83c.png";